import Vue from 'vue'
import VueRouter from 'vue-router'
import pcRoutes from "./pc.js"

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	routes: pcRoutes
})

// 全局前置守卫
// router.beforeEach((to, from, next) => {
// 	const token = localStorage.getItem('token'); // 获取 token

// });

export default router